import { render } from "./LiveSupport.vue?vue&type=template&id=27e26528"
import script from "./LiveSupport.vue?vue&type=script&lang=js"
export * from "./LiveSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__